import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";

const AppConfigContext = createContext({
  appName: "SONDA",
  api: {
    base: "",
    test: "",
    report: "",
    acquire: "",
  },
  features: {
    bypassCompatibilityDefault: false,
  },
});

export const AppConfigProvider = ({ children }) => {
  const hostIsLocal = ["localhost", "127.0.0.1"].includes(window.location.hostname);

  const value = {
    appName: import.meta.env.VITE_APP_NAME ?? "SONDA",
    appFullname: import.meta.env.VITE_APP_FULLNAME ?? "SONDA Screener",
    api: {
      base: import.meta.env.VITE_APP_SERVER_URI ?? "",
      test: `${import.meta.env.VITE_APP_SERVER_URI}/${import.meta.env.VITE_APP_TEST_SERVICE_API_VERSION}/`,
      report: `${import.meta.env.VITE_APP_SERVER_URI}/${import.meta.env.VITE_APP_REPORT_SERVICE_API_VERSION}/`,
      acquire: `${import.meta.env.VITE_APP_SERVER_URI}/${import.meta.env.VITE_APP_DATA_ACQUISITION_API_VERSION}/`,
    },
    features: {
      bypassCompatibilityDefault: hostIsLocal,
    },
  };

  return <AppConfigContext.Provider value={value}>{children}</AppConfigContext.Provider>;
};

AppConfigProvider.propTypes = { children: PropTypes.node.isRequired };

export const useAppConfig = () => useContext(AppConfigContext);
